import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/calendar': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 64c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h48v-52c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128v-52c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48zM394 464c3.3 0 6-2.7 6-6v-298h-352v298c0 3.3 2.7 6 6 6h340z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/calendar.js
// module id = 1702
// module chunks = 0